import { IApplicationState } from '../../types/redux';
import { dealTypeFromJsonQuery } from '../../utils/category';
import { selectJsonQuery } from './selectJsonQuery';

export const selectDealType = (state: IApplicationState) => {
  const jsonQuery = selectJsonQuery(state);

  return dealTypeFromJsonQuery(jsonQuery);
};
